import { FilterForm } from "@/types/filfer.type";
import { normalizeName } from "@/utils/normalize";
import { drcdata } from "./poligon.data";

export const initFilter = (): FilterForm => ({
  disease: "monkeypox",
  prov: "",
  zs: "",
  year: `${new Date().getFullYear()}`,
  numsem: "",
  lastWeek: "",
  week1: 1,
  week2: "",
});

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: 5 }, (_, i) => {
  const year = currentYear - i;
  return { value: year.toString(), label: year.toString() };
});

export const getWeekOptions = (lastWeek?: number | any): any[] => {
  return Array.from({ length: lastWeek }, (_, i) => {
    const weekNumber = i + 1;
    return {
      value: `${weekNumber}`,
      label: `Semaine ${weekNumber}`,
    };
  });
};

export const provinceOptions = drcdata.features.map((feature) => {
  const nom = feature.properties.NOM;
  return {
    value: nom, // ex: "Kasaï-Oriental" => "kasaioriental"
    label: nom,
  };
});

export const getZoneOptionsByProvince = (
  province: string,
  zonesData: any
): { value: string; label: string }[] => {

  if (!province || !zonesData) return [];

  const selectedProvince = normalizeName(province);

  return zonesData
    ?.find((feature: any) => {
      const zoneProvince = normalizeName(feature.name);
      return zoneProvince === selectedProvince;
    })?.zones?.map((zone: any) => ({
      value: normalizeName(zone?.name),
      label: zone?.name,
    }));
  // if (!province || !zonesData?.features) return [];

  // const selectedProvince = normalizeName(province);

  // return zonesData.features
  //   .filter((feature: any) => {
  //     const zoneProvince = normalizeName(feature.properties.PROVINCE);
  //     return zoneProvince === selectedProvince;
  //   })
  //   .map((feature: any) => ({
  //     value: normalizeName(feature.properties.NOM || feature.properties.Nom),
  //     label: feature.properties.NOM || feature.properties.Nom,
  //   }));
};

// export const getFilteredGeoData = (filter: FilterForm, zonesData?: any) => {
//   if (!filter.province) {
//     return drcdata; // toutes les provinces
//   }

//   const selectedProvince = normalizeName(filter.province);

//   const filteredZones =
//     zonesData?.features.filter((zone: any) => {
//       const zoneProvince = normalizeName(zone.properties.PROVINCE);
//       return zoneProvince === selectedProvince;
//     }) || [];

//   // Nouvelle structure GeoJSON propre
//   return {
//     type: 'FeatureCollection',
//     features: filteredZones,
//   };
// };

// export const getFilteredGeoData = (filter: FilterForm, zonesData?: any) => {
//   const provinceName = filter.province?.toLowerCase().replace(/[-_ ]/g, '');

//   if (!provinceName || !zonesData?.features?.length) {
//     return drcdata; // carte complète RDC
//   }

//   const filtered = zonesData.features.filter((zone: any) => {
//     const z = zone.properties.PROVINCE?.toLowerCase().replace(/[-_ ]/g, '');
//     return z === provinceName;
//   });

//   return {
//     ...zonesData,
//     features: filtered,
//   };
// };

export const getFilteredGeoData = (
  filter: FilterForm,
  zonesData?: any,
  isDrc: boolean = false
) => {
  const provinceName = normalizeName(filter?.prov as any);
  const zoneName = normalizeName(filter?.zs as any);

  //   Si aucune province ou si pas de données, retourner toute la carte
  // if (!provinceName || !zonesData?.features?.length) {
  //   return drcdata;
  // }

  if (!provinceName) {
    return isDrc ? drcdata : zonesData;
  }

  // Filtrer les zones par province
  let filteredZones = zonesData.features.filter((zone: any) => {
    const zoneProvince = normalizeName(zone.properties.PROVINCE);
    return zoneProvince === provinceName;
  });

  // Si une zone est spécifiée, filtrer aussi par zone
  if (zoneName) {
    filteredZones = filteredZones.filter((zone: any) => {
      const zoneNom = normalizeName(zone.properties.NOM || zone.properties.Nom);
      return zoneNom === zoneName;
    });
  }

  // Retourner un GeoJSON valide
  return {
    ...zonesData,
    features: filteredZones,
  };
};

// export const normalize = (str: string) =>
//   str?.toLowerCase().replace(/[\s-_]/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const mergeGeoDataWithHealthData = (
  geojson: any,
  healthRecords: any[] = []
) => {
  if (!healthRecords || healthRecords?.length === 0) {
    return geojson;
  }
  const healthMap = new Map(
    healthRecords.map((rec) => [normalizeName(rec.ZS), rec])
  );

  const enriched = geojson.features.map((feature: any) => {
    const zsName = normalizeName(feature.properties.Nom);
    const health = healthMap.get(zsName);
    return {
      ...feature,
      properties: {
        ...feature.properties,
        ...health,
      },
    };
  });

  if (enriched.length === 0) {
    return geojson;
  }

  return {
    ...geojson,
    features: enriched,
  };
};
